<script>
import baseMixin from '@mixins/baseMixin'
import TheDebugBar from '@components/dev/the-debug-bar.vue'
import ServiceStatusAlert from '@/components/app/service-status-alert.vue'

export default {
  components: {
    TheDebugBar,
    ServiceStatusAlert,
  },
  mixins: [baseMixin],
}
</script>

<style lang="scss" scoped>
.r2b_bg {
  background-image: url('https://anzukmedia.blob.core.windows.net/assets/cl/img/bg/bg_public_min.jpg');
  background-image: linear-gradient(
      172deg,
      rgba(61, 48, 136, 0.83) 37%,
      rgba(61, 48, 136, 0.83) 0,
      #3d3088 100%,
      #3d3088
    ),
    url('https://anzukmedia.blob.core.windows.net/assets/cl/img/bg/bg_public_min.jpg');
  background-position: center;
  background-size: cover;
  opacity: 1;
  position: relative;
}
</style>

<template>
  <v-app id="client-login">
    <ServiceStatusAlert />
    <TheDebugBar />

    <v-main class="r2b_bg">
      <v-container class="fill-height" fluid>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6>
            <slot />
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
